import React from "react";
import Centerdetails from "../../../Pages/Public/Centerdetails";

const Centerdetailscard = ({proposal, proposalId, shortlistedCenters, isEditable}) => {
  // Separate recommended and other options
  const recommendedOptions = proposal?.proposedOptions?.filter(option => option.isRecommended) || [];
  const otherOptions = proposal?.proposedOptions?.filter(option => !option.isRecommended) || [];

  const renderCenterDetails = (option, index) => (
    <div 
      key={index}
      id={`center-details-${option.centerName}`}
    >
      <Centerdetails
        proposalId={proposalId}
        proposal={proposal}
        option={option}
        id={option.id}
        centerName={option.centerName}
        inventoryDescription={option.inventoryDescription}
        billableSeats={option.billableSeats}
        pricePerSeat={option.pricePerSeat}
        totalRentPerMonth={option.totalRentPerMont}  
        amenities={option.amenities}
        termsAndConditions={option.terms}
        virtualTours={option.virtualTours}
        location={option.location}
        layouts={option.layouts}
        photos={option.photos}
        availableFrom={option.availabilityDate}
        parkingCharges={option.parkingCharges}
        securityDeposit={option.securityDeposit}
        bikeParkingCost={option.bikeParkingCost}
        carParkingCost={option.carParkingCost}
        shortlistedCenters={shortlistedCenters}
        isEditable={isEditable}
      />
    </div>
  );

  return (
    <div className="container">
      {/* Render recommended options first */}
      {recommendedOptions.map((option, index) => renderCenterDetails(option, index))}
      
      {/* Then render other options */}
      {otherOptions.map((option, index) => renderCenterDetails(option, index))}
    </div>
  );
};

export default Centerdetailscard;
